import { JSX, ReactNode } from "react";

import { cn } from "@/utils/cn.ts";

interface TagProps {
  children: ReactNode;
  type?: "rounded" | "square";
  disabled?: boolean;
  className?: string;
}

const Tag = ({ type = "rounded", disabled = false, children, className }: TagProps): JSX.Element => {
  return (
    <div
      className={cn(
        "bg-surface-container-high w-fit font-semibold text-white transition-colors",
        {
          "hover:bg-on-primary rounded-full px-5 py-[1.063rem] text-sm uppercase leading-4 hover:text-black-1":
            type === "rounded",
          " rounded-md bg-black-opacity-2 px-[0.625rem] py-2  hover:bg-orange-1": type === "square",
          "!bg-orange-1 hover:!text-white": disabled,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Tag;
